import { render } from "./NotRegistered.vue?vue&type=template&id=09810755"
import script from "./NotRegistered.vue?vue&type=script&lang=js"
export * from "./NotRegistered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__